import {
  businessTermListSchema,
  businessTermSchema,
  customerCategoryListSchema,
  customerCategorySchema,
  type BusinessTermWrite,
  type CustomerCategoryWrite,
} from '@erp/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api-client';
export const businessTermKeys = ['settings', 'business-terms'] as const;
export const customerCategoryKeys = ['settings', 'customer-categories'] as const;
export function useBusinessTerms(enabled = true) {
  return useQuery({
    queryKey: businessTermKeys,
    queryFn: () => apiFetch('/api/v1/settings/business-terms', businessTermListSchema),
    enabled,
  });
}
export function useSaveBusinessTerm() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string | null; input: BusinessTermWrite }) =>
      apiFetch(`/api/v1/settings/business-terms${id ? `/${id}` : ''}`, businessTermSchema, {
        method: id ? 'PUT' : 'POST',
        body: input,
      }),
    onSuccess: async () => {
      await Promise.all(
        [businessTermKeys, ['payment-terms'], ['tenant-setup']].map((queryKey) =>
          client.invalidateQueries({ queryKey }),
        ),
      );
    },
  });
}
export function useCustomerCategories() {
  return useQuery({
    queryKey: customerCategoryKeys,
    queryFn: () => apiFetch('/api/v1/settings/customer-categories', customerCategoryListSchema),
  });
}
export function useSaveCustomerCategory() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string | null; input: CustomerCategoryWrite }) =>
      apiFetch(
        `/api/v1/settings/customer-categories${id ? `/${id}` : ''}`,
        customerCategorySchema,
        { method: id ? 'PUT' : 'POST', body: input },
      ),
    onSuccess: async () => {
      await Promise.all(
        [customerCategoryKeys, ['partners'], ['customers']].map((queryKey) =>
          client.invalidateQueries({ queryKey }),
        ),
      );
    },
  });
}
